import { createAction, handleActions } from 'redux-actions';
import { v4 as uuid } from 'uuid';
const initialState = {
    activeFlight: null,
    activeAirport: null,
    hoveredAirport: null,
    hoveredFlight: null,
    loading: false,
    flights: [],
    airports: [],
    lastUpdate: new Date()
};
const setState = createAction('setState', flightsStatusResponse => {
    const flights = [];
    const airports = [];
    for (const flight of flightsStatusResponse) {
        if (!flight.arrival.airport.latitude ||
            !flight.arrival.airport.longitude ||
            !flight.departure.airport.latitude ||
            !flight.departure.airport.longitude) {
            continue;
        }
        flights.push(Object.assign(Object.assign({}, flight), { uniqueId: uuid() }));
        if (!airports.find(airport => {
            return airport.iata === flight.departure.airport.iata;
        })) {
            airports.push(Object.assign(Object.assign({}, flight.departure.airport), { uniqueId: uuid() }));
        }
        if (!airports.find(airport => {
            return airport.iata === flight.arrival.airport.iata;
        })) {
            airports.push(Object.assign(Object.assign({}, flight.arrival.airport), { uniqueId: uuid() }));
        }
    }
    return {
        flights,
        airports,
        hoveredAirport: null,
        hoveredFlight: null,
        activeAirport: null,
        activeFlight: null,
        loading: false,
        lastUpdate: new Date()
    };
});
const setLoading = createAction('setLoading');
const setSelectedFlight = createAction('setSelectedFlight');
const setSelectedAirport = createAction('setSelectedAirport');
const setHoveredAirport = createAction('setHoveredAirport');
const setHoveredFlight = createAction('setHoveredFlight');
const reducer = handleActions({
    [setState.toString()]: (state, action) => (Object.assign({}, action.payload)),
    [setSelectedFlight.toString()]: (state, action) => (Object.assign(Object.assign({}, state), { activeFlight: action.payload })),
    [setSelectedAirport.toString()]: (state, action) => (Object.assign(Object.assign({}, state), { activeAirport: action.payload })),
    [setHoveredAirport.toString()]: (state, action) => (Object.assign(Object.assign({}, state), { hoveredAirport: action.payload })),
    [setHoveredFlight.toString()]: (state, action) => (Object.assign(Object.assign({}, state), { hoveredFlight: action.payload })),
    [setLoading.toString()]: (state, action) => (Object.assign(Object.assign({}, state), { loading: action.payload }))
}, initialState, { namespace: 'flightStatus' });
export default reducer;
export { setState, setLoading, setSelectedFlight, setSelectedAirport, setHoveredFlight, setHoveredAirport };
